import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import appConfig from '@config';

@Injectable({
	providedIn: 'root'
})
export class MigrationsDataService {
	private http = inject(HttpClient);

	BASE_API = 'core/data_migrations/';

	checkMigrations(data: FormData, path: string): Observable<any> {
		return this.http.post<any>(`${appConfig.API_PATH}${this.BASE_API}${path}/`, data);
	}

	runMigrationFile(id: number, path: string): Observable<any> {
		return this.http.post<any>(`${appConfig.API_PATH}${this.BASE_API}${id}/${path}/`, {});
	}
}
